import { CloudApiError } from './api-client'
import { errorMessage } from './fs-access'

/** 我們自己拋的錯誤型別。訊息本身已經可行動，不需要加註來源。 */
const NAMED_ERRORS = ['Error', 'EncryptedArchiveError', 'UnreadableArchiveError', 'SourceUnauthorizedError']

export function isExpectedFailure(cause: unknown): boolean {
  return cause instanceof DOMException
    || cause instanceof CloudApiError
    || (cause instanceof Error && NAMED_ERRORS.includes(cause.name))
}

/**
 * 取第一個屬於我們自己程式的堆疊框。
 *
 * 意外型別只帶訊息是不夠的——「Illegal invocation」這種訊息在整個應用裡可能來自任何
 * 一個原生呼叫。上一輪加了步驟與型別把範圍縮到單一函式，但單一函式裡仍有十幾個候選，
 * 因此這一輪把來源也帶上。
 *
 * 只取一框：訊息會寫進佇列項並顯示在明細那一列上，整份堆疊會把它撐爆。
 */
export function originFrame(cause: unknown): string {
  if (!(cause instanceof Error) || typeof cause.stack !== 'string') return ''
  const frame = cause.stack.split('\n')
    .map(line => line.trim())
    .find(line => line.startsWith('at ') && !line.includes('stepError') && !line.includes('originFrame'))
  return frame ? frame.replace(/^at\s+/, '') : ''
}

/**
 * 意外錯誤附上步驟、型別與來源。
 *
 * 上傳有五個各自捕捉錯誤的步驟，而它們都只把 error.message 放上畫面。遇到不是我們自己
 * 拋的錯誤（例如瀏覽器的 TypeError）時，畫面上只會出現像「Illegal invocation」這種
 * 無從追查的字串，且因為已被捕捉，主控台也不會有任何東西。
 */
export function stepError(step: string, cause: unknown): string {
  const message = errorMessage(cause)
  if (isExpectedFailure(cause)) return message
  const origin = originFrame(cause)
  const type = cause instanceof Error ? cause.name : typeof cause
  return `${message}（${step} · ${type}${origin ? ` · ${origin}` : ''}）`
}
